import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { aiActions } from '../../actions/aiActions';
import ChatMessages from './ChatMessages';
import styles from './ChatWindow.module.css';
import { parseLLMResponse } from './ParseLLMResponseMsgs';
import PromptInput from './PromptInput';
import axios from 'axios';
import { url } from '../../config';

const ChatWindow = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingAndStreaming, setLoadingAndStreaming] = useState(false);
  const [chatComplete, setChatComplete] = useState(false);
  const [dbReadyChat, setDbReadyChat] = useState(null);

  const dispatch = useDispatch();
  const selectedChat = useSelector(state => state.aiReducer.selectedChat);

  const handleStreamingResponseTokens = async (newMsg, response) => {
    const reader = response?.body?.getReader();
    const decoder = new TextDecoder('utf-8');
    let done = false;
    let decodedContent = '';

    setLoading(false);
    while (!done) {
      const { value, done: doneReading } = await reader.read();
      done = doneReading;
      if (value) {
        decodedContent += decoder.decode(value, { stream: true });

        setMessages(prev => {
          const updated = [...prev];
          const lastIndex = updated.length - 1;
          updated[lastIndex] = {
            ...updated[lastIndex],
            content: decodedContent,
          };
          return updated;
        });
      }
    }

    decodedContent += decoder.decode();

    // After showing the streaming response to user, parse it to clean up and format links and replace whats shown with the parsed version
    setMessages(prev => {
      const updated = [...prev];
      const lastIndex = updated.length - 1;

      const parsedResponse = parseLLMResponse(updated[lastIndex].content);

      updated[lastIndex] = { ...updated[lastIndex], content: parsedResponse };
      // Set db object state to trigger useEffect for sending the chat to the db, only if
      // the llm response isn't a refusal to answer response
      if (
        parsedResponse !=
          "I can only answer questions regarding information contained in Council legal memos." &&
        parsedResponse !=
          'I do not have the necessary information to answer that question.' &&
        parsedResponse.length > 65
      ) {
        setDbReadyChat({
          chat_title: newMsg
            .split(' ')
            .slice(0, 4)
            .join(' ')
            .replace(/^./, c => c.toUpperCase()),
          user_prompt: newMsg,
          system_response: parsedResponse,
        });
      }
      return updated;
    });
  };

  const handleStartNewChat = () => {
    setMessages([]);
    setChatComplete(false);
    dispatch({ type: aiActions.SET_SELECTED_CHAT_HISTORY, payload: null });
  };

  const handleSendPrompt = async userPrompt => {
    if (!userPrompt.trim()) return;
    const newMsg = userPrompt;
    setMessages(prev => [...prev, { role: 'user', content: userPrompt }]);
    setMessages(prev => [...prev, { role: 'system', content: '' }]);

    setLoadingAndStreaming(true);
    setLoading(true);

    fetch(`${url}/api/chatbot/chat-proxy/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': axios.defaults.headers.common['Authorization'],
      },
      body: JSON.stringify({ message: newMsg }),
    })
      .then(async response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status};`);
        }
        await handleStreamingResponseTokens(newMsg, response);
        setChatComplete(true);
      })
      .catch(error => {
        console.error(error);

        setMessages(prev => [
          ...prev,
          { role: 'system', content: 'Sorry, something went wrong.' },
        ]);
      })
      .finally(() => {
        setLoadingAndStreaming(false);
        setLoading(false);
      });
  };

  // if Chat is complete, than chat is no longer active, else chat is still active
  const isChatActive = !chatComplete;
  useEffect(() => {
    if (dbReadyChat) {
      dispatch({ type: aiActions.ADD_CHAT, payload: dbReadyChat });
    }
  }, [dbReadyChat, dispatch]);

  return (
    <div className={styles.chatWindow}>
      <div className={styles.messageList}>
        <ChatMessages
          messages={messages}
          isLoading={loading}
          selectedChat={selectedChat}
        />
      </div>
      <PromptInput
        isChatActive={isChatActive}
        onStartNewChat={handleStartNewChat}
        onSendPrompt={handleSendPrompt}
        isLoadingAndStreaming={loadingAndStreaming}
        isLoading={loading}
      />
    </div>
  );
};
export default ChatWindow;
